jQuery(function($){
    generateFilterLinkFnc();
    $('.fqa-block-cta').insertAfter($('.fqa-tab .fqa-tab-item:nth-child('+parseInt($('.fqa-tab-item').length/2)+')'));
    $('.fqa-tab-title').click(function(){
        $(this).closest('.fqa-tab-item').toggleClass('active');
    });
    $('.search-enter').click(function(){
        $('.mod-faq-search').addClass('active');
    });
    $('.search-close').click(function(){
        $('.mod-faq-search').removeClass('active');
        $('.mod-faq-filter__category a.active').removeClass('active');
        $('.mod-faq-filter__category a[href="#all"]').addClass('active');
        $('.mod-faq-search .form-control').val('');
        filterFaqs();
    });
    $('.view-more-category').click(function(){
        $('.mod-faq-filter__category').toggleClass('viewmore');
    });
    $('.mod-faq-filter__category a').click(function(){
        $(this).closest('.mod-faq-filter__category').find('.active').removeClass('active');
        $(this).addClass('active');
        filterFaqs();
        return false;
    });
    $('.mod-faq-filter.mobile select.filter-faq').change(function(){
        $('.mod-faq-filter__category a.active').removeClass('active');
        $('.mod-faq-filter__category a[href="#'+$(this).val()+'"]').addClass('active');
        filterFaqs();
    });
    $('.mod-faq-search').on('keyup','.form-control',function(){
        $('.mod-faq-filter__category a.active').removeClass('active');
        $('.mod-faq-filter__category a[href="#all"]').addClass('active');
        filterFaqs();
    });
    $('.ntm-faq-sel > div').click(function(){
        $(this).toggleClass('active');
    });
    $('.ntm-faq-sel > ul').on('click','li',function(){
        $(this).closest('.filter-faq-form').find('.ntm-faq-sel > div').removeClass('active');
        $(this).closest('.filter-faq-form').find('.ntm-faq-sel > div').html($(this).html());
        $(this).parent().find('.active').removeClass('active');
        $(this).addClass('active');
        $(this).closest('.filter-faq-form').find('select').val($(this).attr('value'));
        $(this).closest('.filter-faq-form').find('select').change();
    });
    function generateFilterLinkFnc() {
        var elemento = $('.mod-faq-header'),
            t = elemento.find(".mod-faq-filter__category"),
            n = elemento.find(".filter-faq").removeClass("select-done"),
            ntm_s = elemento.find(".ntm-faq-sel ul");
        $('.fqa-tab-item').each(function () {
            var i = $(this).attr("data-category").replace(new RegExp("'", "g"), '"');
            JSON.parse(i).forEach(function (i) {
                if (0 === t.find('[href="#' + i.id + '"]').length) {
                    var o = t.find(".filter-category")[0].outerHTML;
                    (o = $(o).removeClass("active")), o.attr("href", "#" + i.id), o.html(i.name), t.append(o);
                }
                if (0 === n.find('[value="' + i.id + '"]').length) {
                    var s = '<option value="' + i.id + '">' + i.name + "</option>";
                    n.append(s);
                    ntm_s.append(s.replace('option','li'));
                }
            });
        });
    }
    function filterFaqs() {
        var current_cat = $('.mod-faq-filter__category a.active').attr('href').replace('#','');
        var search_term = $('.mod-faq-search.active');
        $('.fqa-tab-item').each(function(){
            var i = $(this).attr("data-category").replace(new RegExp("'", "g"), '"');
            var element = $(this);
            element.hide();
            if (search_term.length > 0) {
                console.log($(this).text());
                if ( $(this).text().toLowerCase().includes(search_term.find('.form-control').val().toLowerCase()) ) {
                    element.show();
                }
            } else {
                JSON.parse(i).forEach(function (i) {
                    if (current_cat == 'all' || i.id == current_cat) {
                        element.show();
                    }
                });
            }
        });
        if (current_cat == 'all' || current_cat == 'active-learning') {
            $('.fqa-block-cta').show();
            var count = $('.fqa-tab .fqa-tab-item:visible').size();
            $('.fqa-tab-item:visible').each(function(){
                if ( count <= ($('.fqa-tab .fqa-tab-item:visible').size()/2) ) {
                    $('.fqa-block-cta').insertAfter($(this));
                    return false;
                }
                count--;
            });
        } else {
            $('.fqa-block-cta').hide();
        }
    }
});
